import {
  Anchor,
  Icon,
  LockHollowSVG,
  type SvgComponentType,
} from "@newsela/angelou";

import {
  lockedIconCss,
  subjectAreaAnchorCss,
  subjectAreaIconCss,
  titleCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectItems/SubjectItem/SubjectItem.styles";

const SubjectItem = ({
  title,
  SvgComponent,
  href,
  locked,
  iconClass = "apply-fill",
  dataQASelector,
}: ISubjectAreaItem) => {
  return (
    <Anchor
      __cssFor={subjectAreaAnchorCss}
      href={href}
      dataProps={{ "data-qa-selector": dataQASelector }}
    >
      {locked ? (
        <Icon
          __cssFor={lockedIconCss}
          __classNameFor={{ root: "apply-stroke" }}
          SvgComponent={LockHollowSVG as SvgComponentType}
          dataProps={{ "data-testid": "locked-subject-item-icon" }}
        />
      ) : (
        SvgComponent && (
          <Icon
            __cssFor={subjectAreaIconCss}
            SvgComponent={SvgComponent}
            __classNameFor={{ root: iconClass }}
            dataProps={{ "data-testid": "unlocked-subject-item-icon" }}
          />
        )
      )}
      <div css={titleCss}>{title}</div>
    </Anchor>
  );
};

type IconClassType = "apply-fill" | "apply-stroke";

interface ISubjectAreaItem {
  href: string;
  title: string;
  locked?: boolean;
  dataQASelector: string;
  iconClass?: IconClassType;
  SvgComponent?: SvgComponentType;
}

SubjectItem.displayName = "SubjectItem";
export { SubjectItem };
